import React, { useState, useContext, useEffect } from "react";
import MDTypography from "components/MDTypography";
import Swal from "sweetalert2";
import AddTherapistToAppDayReq from "../../../../Classes/Models/Requests/AddManyToManyReq";
import SearchTherapistsReq from "../../../../Classes/Models/Requests/Users/SearchUser";
import AsyncSelect from "react-select/async";
import { LanguageContext } from "App";
import UsersApi from "../../../../Classes/API/UsersApi";
import AppointmentsApi from "../../../../Classes/API/Appointments/AppointmentsApi";
import "./addtherapist.scss";
const AddTherapistToDay = ({ setIsLoaded, AppDay, GetAppDayById }) => {
  const { translations } = useContext(LanguageContext);
  const [TherapistSearch, setTherapistSearch] = useState();
  const [Therapist, setTherapist] = useState({});
  const [defaultOptions, setDefaultOptions] = useState([]);

  useEffect(() => {
    const loadInitialOptions = async () => {
      const options = await GetTherapists();
      setDefaultOptions(options || []);
    };
    loadInitialOptions();
  }, []);

  const AddToDay = async () => {
    let addReq = new AddTherapistToAppDayReq();
    addReq.Id1 = AppDay.id;
    addReq.Id2 = Therapist.id;

      Swal.fire({
      title: "Adding Therapist",
      icon: "info",
      toast: true,
      position: "top-right",
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    let res = await AppointmentsApi.AddTherapistToAppointmentDay(addReq);
    if (res.status == "Success") {
      Swal.fire({
        title: "Added Therapist",
        icon: "success",
        toast: true,
        position: "top-right",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: () => {
          Swal.hideLoading();
          GetAppDayById(AppDay.id);
        },
      });
    } else if (res.message == "Therapist Already Added To Day.") {
      Swal.fire({
        title: "Therapist Already Added",
        icon: "warning",
        toast: true,
        position: "top-right",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: () => {
          Swal.hideLoading();
          GetAppDayById(AppDay.id);
        },
      });
    } else {
      Swal.fire({
        title: res.message,
        icon: "error",
        toast: true,
        position: "top-right",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: () => {
          Swal.hideLoading();
          GetAppDayById(AppDay.id);
        },
      });
    }
    if (res.status == "Success") {
      setIsLoaded(false);
      GetAppDayById(AppDay.id);
    }
  };

  const GetTherapists = async () => {
    let searchReq = new SearchTherapistsReq();
    searchReq.userType = "Therapist";
    searchReq.name = TherapistSearch;

    let res = await UsersApi.SearchUsers(searchReq);

    if (res.status == "Success") {
      let optionsArr = [];
      res.data.list.forEach((item) => {
        console.log("Session: ", item);

        optionsArr.push({
          value: item.getTherapist,
          label: item.name,
        });
      });

      return optionsArr;
    }
  };

  return (
    <div className="card-container">
      <div className="col-md-6">
        <MDTypography
          variant="button"
          fontWeight="bold"
          textTransform="capitalize"
        >
          {translations.appointmentTableaddtherapistcard} &nbsp;
        </MDTypography>

        <MDTypography variant="button" fontWeight="regular" color="text">
          <AsyncSelect
            isClearable={true}
            defaultOptions={defaultOptions}
            loadOptions={GetTherapists}
            onInputChange={setTherapistSearch}
            onChange={(e) => setTherapist(e ? e.value : "")}
            menuPortalTarget={document.body} 
            menuPosition="fixed" 
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }), 
            }}
            placeholder="Select a therapist..."
          />
        </MDTypography>
      </div>
      <div className="col-md-6 mt-4">
        <MDTypography variant="button" fontWeight="regular" color="text">
          <button
            onClick={() => AddToDay()}
            className="btn btn-success"
            disabled={!Therapist}
          >
            +
          </button>
        </MDTypography>
      </div>
    </div>
  );
};

export default AddTherapistToDay;
